import { ref, update, get, DatabaseReference } from 'firebase/database';
import { database as realtimeDb } from '../../config/firebase-client/database';
import { Connection } from '../../../functions/src/types/firestore/EditStep/Connection';
import { getRealtimeDocId } from '../../../functions/src/util/realtime';
import { ConnectionSentinel } from './ConnectionSentinel';

export class EditableDocConnector {
  private realtimeDocId: string;
  private connectionsRef: DatabaseReference;
  public sentinel: ConnectionSentinel;
  constructor(private documentPath: string, private userId: string) {
    this.realtimeDocId = getRealtimeDocId(documentPath);
    this.connectionsRef = ref(realtimeDb, `connections/${this.realtimeDocId}`);
    // TODO: feels a bit clunky... what am I missing?
    this.sentinel = new ConnectionSentinel(
      this.connectionsRef,
      this.connectionClosed.bind(this),
      this.connectionClosed.bind(this),
      this.connectionSevered.bind(this),
      this.connectionCreated.bind(this),
    );
  }

  public connect() {
    return this.sentinel.connect();
  }

  public disconnect() {
    return this.sentinel.disconnect();
  }

  private async connectionCreated() {
    const currentConnections = await this.getCurrentConnections();
    const userIdsConnected = currentConnections?.userIdsConnected || [];
    const updatedUserIds = [...new Set([...userIdsConnected, this.userId])];
    await this.updateUserIdsConnected(updatedUserIds);
  }

  public async getCurrentConnections(): Promise<Connection | null> {
    const snapshot = await get(this.connectionsRef);
    return snapshot.val();
  }

  private async updateUserIdsConnected(newUserIds: string[]) {
    await update(this.connectionsRef, {
      //ensures doc path is set if this is the first user
      documentPath: this.documentPath,
      userIdsConnected: newUserIds,
    });
  }

  private async connectionSevered() {
    const currentConnections = await this.getCurrentConnections();
    const userIdsConnected = currentConnections?.userIdsConnected || [];
    return {
      userIdsConnected,
    };
  }

  private async connectionClosed() {
    const currentConnections = await this.getCurrentConnections();
    const userIdsConnected = currentConnections?.userIdsConnected || [];
    await this.updateUserIdsConnected(this.withoutUserId(userIdsConnected));
  }

  public withoutUserId(connectedIds: string[]) {
    return connectedIds.filter((id) => {
      return id !== this.userId;
    });
  }
}
